import { debounceTime, filter, fromEvent, map, mergeMap, switchMap, throwError } from "rxjs";
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.overlayCreated = false;
        this.input = this.querySelector('input[type="search"]');
        this.closeBtn = this.querySelector('button[close]');
        this.resultsWrapper = this.querySelector('#results-wrapper');
        this.routes = window.routes;
        this.form = this.querySelector('form');
    }
    connectedCallback() {
        this.closeBtn.addEventListener('click', this.close.bind(this));
        this.setSearcher();
        this.desactivateForm();
    }
    desactivateForm() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
        });
    }
    setSearcher() {
        const event$ = fromEvent(this.input, 'input');
        event$.pipe(debounceTime(250), map((event) => event.target.value.trim()), filter((value) => value.length > 0), switchMap((value) => {
            const url = `${this.routes.predictiveSearch}?q=${value}&resources[type]=product,collection,article&resources[limit]=10&section_id=predictive-search`;
            return fetch(url);
        }), mergeMap(async (response) => {
            if (!response.ok) {
                const error = new Error(String(response.status));
                this.close();
                return throwError(() => error);
            }
            return await response.text();
        }), map((text) => new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results').innerHTML)).subscribe({
            next: (result) => {
                this.resultsWrapper.innerHTML = '<button close>&times;<button>';
                this.resultsWrapper.innerHTML += result;
                this.resultsWrapper.querySelector('button[close]').addEventListener('click', this.close.bind(this));
            },
            error: (error) => {
                console.error(error);
            }
        });
    }
    open() {
        this.classList.add('-active');
        this.input.focus();
        document.documentElement.style.overflow = 'hidden';
        if (!this.overlayCreated)
            this.createOverlay();
    }
    close() {
        this.classList.remove('-active');
        document.documentElement.style.overflow = 'auto';
        this.input.value = '';
        this.resultsWrapper.innerHTML = '';
        this.removeOverlay();
    }
    createOverlay() {
        const overlay = document.createElement('div');
        overlay.classList.add('predictive-search-overlay');
        document.body.appendChild(overlay);
        overlay.addEventListener('click', this.close.bind(this));
        this.overlayCreated = true;
    }
    removeOverlay() {
        const overlay = document.querySelector('.predictive-search-overlay');
        if (overlay)
            overlay.remove();
        overlay.removeEventListener('click', this.close.bind(this));
        this.overlayCreated = false;
    }
}
customElements.define('predictive-search', PredictiveSearch);
class OpenSearch extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.search = document.querySelector('predictive-search');
        this.button.addEventListener('click', this.open.bind(this));
    }
    open() {
        this.search.open();
    }
}
customElements.define('open-search', OpenSearch);
